import { useQuery } from 'hooks/useCustomQuery';
import getPartner from 'API/Partner/getPartner';

const useGetPartnerByID = (partnerId, onSuccess, resetToMainTable, enabled) => {
    return useQuery({
        queryKey: ['partner', partnerId],
        queryFn: async () => {
            return getPartner(partnerId);
        },
        enabled: enabled && Boolean(partnerId),
        onSuccess: (data) => {
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            console.error('Error fetching partner:', error);
            if (resetToMainTable) {
                resetToMainTable();
            }
        },
        refetchOnMount: true, // Always refetch when component mounts
        refetchOnWindowFocus: false,
        staleTime: 0,
        cacheTime: 0, // Don't cache to ensure fresh data
    });
};

export default useGetPartnerByID;
